module.exports = __webpack_public_path__ + "img/multiAsset_blue.6de10691.png";